<template>
  <div>

    <!-- <div v-if="$route.params.layout === 'home'" class="join-page pb-5">
      <h3 class="logo"></h3>

      <div class="container pt-5">
          <card class="pb-5">
            <h6 class="pull-right"><a class="close" href="#" @click.prevent="$router.push('/home')">X</a></h6>
            <h4 class="header mt-2">{{boardMst.boardNm}}</h4>

            <hr class="mb-3"/>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>

          </card>

      </div>
      <app-footer></app-footer>
    </div> -->

    <slider-layout v-if="$route.params.layout === 'home'" is-show-overlay>
      <template #default>
          <h4 class="header mt-2">{{boardMst.boardNm}}</h4>
          <hr class="mb-3"/>
          <router-view></router-view>
      </template>
    </slider-layout>


    <default-layout v-if="$route.params.layout !== 'home'"></default-layout>

  </div>
</template>
<script>
import store from '@/store/'  
import AppFooter from 'src/components/Pages/Views/Layout/AppFooter'
import DefaultLayout from './DefaultLayout.vue'
import SliderLayout from '../Views/Home/Layout/SliderLayout.vue'

  export default {
    components: {
      AppFooter,
      DefaultLayout,
      SliderLayout,
    },
    beforeRouteEnter (to, from, next) {

      store.dispatch('board/boardMst',to.params.boardNo )
      .then(next)

    },    
    created () {
      
      //this.$store.dispatch('board/boardMst',this.$route.params.boardNo )

      /*
      new BoardProxy()
      .getBoardMstInfo( this.$route.params.boardNo )
      .then(res => this.boardMst = Object.assign({},{...res.item}) )
      */
      

    },
    mounted() {
        
        this.$store.dispatch('common/setMenuTitle', this.boardMst.boardNm);

    },
    methods: {
    },
    computed: {
      boardMst() {
        return this.$store.state.board.boardMst
      }
    }
  }
</script>
<style>
  .join-page {
    background-image: url(/static/commons/images/main_bg.jpg);
    min-height: 100vh;
  }  
  .join-page .logo {width: 221px;height: 64px;background: url("/static/commons/images/main_logo.png") no-repeat; margin:0 auto;position: absolute;background-size: contain;z-index: 1000;margin: 30px;}

  .join-page .card label {
    color: #606266;
    font-size: 14px;
  }

</style>
